import { useContext } from "react";
import { AppContext } from "src/contexts/AppContext";

const useApp = () => useContext(AppContext);

export default useApp;
